import React from 'react'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { loginLocation } from '#src/services/routing'
import styles from './styles.css'

const LoggedInNavigation: React.FC = () => {
  const history = useHistory()

  return (
    <div className={styles.navGroup}>
      <Link to={loginLocation(history.location)} className={styles.navItem} rel="nofollow">
        Sign in
      </Link>
    </div>
  )
}

export default LoggedInNavigation
